var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappincirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.19922C68.0176 4.19922 85.6934-13.4766 85.6934-35.2051C85.6934-56.9336 68.0176-74.6094 46.2402-74.6094C24.5117-74.6094 6.83594-56.9336 6.83594-35.2051C6.83594-13.4766 24.5117 4.19922 46.2402 4.19922Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7676-49.707C36.7676-54.8828 41.0645-59.1309 46.2402-59.1309C51.4648-59.1309 55.7129-54.8828 55.7129-49.707C55.7129-45.5078 53.0762-41.9922 49.3652-40.7715L49.3652-22.6562C49.3652-16.3086 48.3398-10.498 46.2402-10.498C44.1406-10.498 43.1152-16.4062 43.1152-22.6562L43.1152-40.7715C39.4531-42.041 36.7676-45.5566 36.7676-49.707ZM40.8691-52.0996C40.8691-50.5371 42.2363-49.1211 43.7988-49.1211C45.459-49.1211 46.7773-50.5371 46.7773-52.0996C46.7773-53.7109 45.459-55.0781 43.7988-55.0781C42.2363-55.0781 40.8691-53.7109 40.8691-52.0996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappincirclefill);
export default __webpack_public_path__ + "static/media/mappin.circle.fill.7155b658f5910833ce4d8b97fd1b32fd.svg";
export { ForwardRef as ReactComponent };